const LEGACY_RETURN_KEY = 'coupon-payment-return';
const RECONCILIATION_KEY = 'payment-reconciliation-pending';
const EMAIL_KEY = 'coupon-email';
const AUTO_KEY = 'coupon-suppress-auto';
const SESSION_KEY = 'coupon-session-active';
const PAYMENT_CONTEXT_TTL = 30 * 60 * 1000;

const normalizeCode = value => String(value || '').trim().toUpperCase();
export const getExplicitCoupon = () => localStorage.getItem('coupon') || '';
export const isExplicitCoupon = coupon => Boolean(coupon?.name &&
    (coupon.source === 'btl' || ['by_code', 'code'].includes(coupon.use_method)));
export const clearCouponEmail = () => sessionStorage.removeItem(EMAIL_KEY);
export const enableCouponApplication = () => sessionStorage.removeItem(AUTO_KEY);
export const removeExplicitCoupon = () => {
    localStorage.removeItem('coupon');
    clearCouponEmail();
    enableCouponApplication();
};
export const suppressAutomaticCoupon = () => {
    localStorage.removeItem('coupon');
    clearCouponEmail();
    sessionStorage.setItem(AUTO_KEY, 'true');
};
export const syncExplicitCoupon = (coupon, requestedCode = getExplicitCoupon()) => {
    const requested = normalizeCode(requestedCode);
    if (isExplicitCoupon(coupon) && requested && normalizeCode(coupon.name) === requested) {
        localStorage.setItem('coupon', coupon.name);
        if (coupon.locked_email) setCouponEmail(coupon.locked_email);
        return coupon.name;
    }
    localStorage.removeItem('coupon');
    if (!coupon?.locked_email) clearCouponEmail();
    return '';
};
// Alias temporal para consumidores antiguos; retirar un código explícito no suprime automáticos.
export const clearCartCoupon = removeExplicitCoupon;
export const couponRequestOptions = () => ({
    coupon_email: sessionStorage.getItem(EMAIL_KEY) || '',
    suppress_auto: sessionStorage.getItem(AUTO_KEY) === 'true'
});
export const setCouponEmail = email => sessionStorage.setItem(EMAIL_KEY, email.trim().toLowerCase());
export const initializeCouponSession = (navigationType = performance.getEntriesByType?.('navigation')?.[0]?.type) => {
    // Limpia datos creados por la implementación anterior; el pedido pendiente es la fuente de verdad.
    sessionStorage.removeItem(LEGACY_RETURN_KEY);
    const firstVisit = sessionStorage.getItem(SESSION_KEY) !== 'true';
    sessionStorage.setItem(SESSION_KEY, 'true');
    if (navigationType === 'reload' || firstVisit) removeExplicitCoupon();
    else if (navigationType !== 'back_forward') enableCouponApplication();
    return { accept_btl: false };
};
export const markPaymentDeparture = ({ orderId = '', context = 'fast-checkout' } = {}) => {
    if (orderId) sessionStorage.setItem(RECONCILIATION_KEY, JSON.stringify({
        orderId: String(orderId),
        context,
        createdAt: Date.now()
    }));
    else sessionStorage.removeItem(RECONCILIATION_KEY);
    sessionStorage.removeItem(LEGACY_RETURN_KEY);
    // El cupón y los importes ya viven en el pedido pendiente; no se restauran al carrito.
    if (context === 'fast-checkout') removeExplicitCoupon();
};
export const consumePaymentReconciliation = ({ orderId, context = 'fast-checkout' } = {}) => {
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(RECONCILIATION_KEY)); }
    catch { sessionStorage.removeItem(RECONCILIATION_KEY); return false; }
    if (!pending || Date.now() - Number(pending.createdAt || 0) > PAYMENT_CONTEXT_TTL) {
        sessionStorage.removeItem(RECONCILIATION_KEY);
        return false;
    }
    const matches = String(pending.orderId) === String(orderId) && pending.context === context;
    if (matches) sessionStorage.removeItem(RECONCILIATION_KEY);
    return matches;
};
export const leaveForPayment = (url, options) => {
    markPaymentDeparture(options);
    window.location.href = url;
};
